import { WindowCommand } from './window-command';

export class OpenCaseCommand extends WindowCommand {
  public url: string;

  public constructor(url: string) {
    super('open-case');
    this.url = url;
  }

  public get data() {
    return {
      url: this.url
    };
  }
}
